import packageJson from 'package.json';
import {CloudName, CloudType, Environment} from '@q9elements/ui-kit/common';

export const environment: Environment = {
    version: packageJson.version,
    API_ENDPOINT: 'https://staging-api.elements-eng.cloud/api/v1', 
    API_STATIC_FILE_UPLOAD: 'https://staging-upload.elements-eng.cloud:1443/api',
    APPNAME: 'HD-APP',
    CLOUD_NAME: CloudName.ELEMENTS,
    CLOUD_TYPE: CloudType.PUBLIC,
    DATA_STRUCTURE_URL: 'https://staging-datatable.elements-eng.cloud',
    DIAGRAM_URL: 'https://staging-diagram.elements-eng.cloud',
    DOMAIN: 'elements-eng.cloud',
    ENTERPRISE_URL: 'https://staging-corp.elements-eng.cloud',
    ENV: 'staging',
    GDPR_SUPPORT_LINK: 'https://support.elements.cloud/en/articles/1221094-enable-data-privacy-gdpr-compliance-for-a-ref-model',
    IMPORT_MAP_API: 'https://staging-gateway.elements-eng.cloud/map-import/api/v1',
    IMPORTS_API: 'https://staging-gateway.elements-eng.cloud/import/api/v1',
    INTERCOM_APP_ID: 'sfi4u1en',
    MAIN_APP_URL: 'https://staging-app.elements-eng.cloud',
    MAP_MANAGEMENT_APP: 'https://staging-mapmgt.elements-eng.cloud',
    NO_IMAGE_URL: '../../assets/images/no_image.png',
    PARTNER_APP: 'https://staging-partnermgt.elements-eng.cloud', 
    PREVIEW_HOLDER: '/assets/images/map_placeholder.png', 
    production: true, 
    SENTRY_AUTH_TOKEN: '',
    SENTRY_DSN: '',
    SENTRY_ORG: '',
    SENTRY_PROJECT: 'main-app',
    REF_MODEL_APP: 'https://staging-refmodel.elements-eng.cloud',
    RELEASE_URL: 'https://staging-releasemgt.elements-eng.cloud',
    REMOTE_UNLOCK_TTL: 3600000,
    REPORTS_API_ENDPOINT: 'https://staging-gateway.elements-eng.cloud/report/api/v1',
    REPORTS_APP: 'https://staging-report.elements-eng.cloud',
    SALESFORCE_CLIENT_ID: '3MVG9Rd3qC6oMalVszZtK2Usdv.BRF2ErH1PH2r2f2Aop_iJrJ0nCjq9blRIQKav.Aed1bBpVIVEZuMyw5VJC',
    SALESFORCE_REDIRECT_URL: 'https://staging-app.elements-eng.cloud/auth/callback',
    SALESFORCE_URL_TEST: 'https://test.salesforce.com/services/oauth2/authorize',
    SALESFORCE_URL: 'https://login.salesforce.com/services/oauth2/authorize',
    SECURE_COOKIES: true,
    SYS_ADMIN_APP: 'https://staging-sysadmin.elements-eng.cloud',
    TEAM_APP: 'https://staging-spacemgt.elements-eng.cloud',
    STATIC_FILES_URL: 'https://static.elements-eng.cloud',
    TOASTR_TIMEOUT: 5000,
    UNLOCK_TTL: 180000,
    JAM_TEAM_ID: '',
    MCP_OAUTH_URL: 'https://staging-api.elements-eng.cloud/api/v1/oauth',
    fbConfig: {
        apiKey:'AIzaSyCIrTPqlx_vQu_WFNfkg8IUIzoAL3Ij0gI',
        authDomain:'staging-elements.firebaseapp.com',
        databaseURL: 'https://staging-elements-default-rtdb.firebaseio.com',
        projectId: 'staging-elements',
        appId: '1:742374870043:web:8291e098ca434728fabcbe'
    }
};
